import { render, staticRenderFns } from "./eventBak.vue?vue&type=template&id=20fad0ae&scoped=true&"
import script from "./eventBak.vue?vue&type=script&lang=js&"
export * from "./eventBak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fad0ae",
  null
  
)

export default component.exports